import { CeruleanButton } from 'components/Button'
import Column from 'components/Column'
import iconColor from 'components/iconColor'
import InputContainer from 'components/InputContainer'
import FasCheck from 'components/Legacy/Icons/FasCheck'
import Text from 'components/Text'
import messages from 'lang'
import React from 'react'
import { injectIntl, WrappedComponentProps } from 'react-intl'
import styled from 'styled-components'
import { px } from 'utils'

import Container from '../Modal/Container'
import { SeedQrCode } from '../Modal/TwoFactor'

const Check = styled(FasCheck)`
  ${iconColor('blue600')};
`

const Row = styled.div`
  display: flex;
  align-items: center;

  &:not(:last-child) {
    margin-bottom: 1rem;
  }
`

const QrWrapper = styled(InputContainer)`
  align-self: center;
`

const Action = styled(Text)`
  margin-left: 1.5rem;
`

const Setup = ({ intl }: WrappedComponentProps) => (
  <Container
    sub={intl.formatMessage(messages.sub_title_setup_2fa)}
    title={intl.formatMessage(messages.title_setup_2fa)}
  >
    <Column>
      <InputContainer>
        <Row>
          <Check size={px(1.1)} />

          <Action color='black' weight={600}>
            {intl.formatMessage(messages.description_setup_2fa_app)}
          </Action>
        </Row>

        <Row>
          <Check size={px(1.1)} />

          <Action color='black' weight={600}>
            {intl.formatMessage(messages.description_setup_2fa_qr)}
          </Action>
        </Row>
      </InputContainer>

      <QrWrapper>
        <SeedQrCode />
      </QrWrapper>

      <CeruleanButton e2e='nextButton' type='submit'>
        {intl.formatMessage(messages.button_next)}
      </CeruleanButton>
    </Column>
  </Container>
)

export default injectIntl(Setup)
